"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SampleAggregator = void 0;
/**
 *
 * The Sample Aggregator looks at all samples within a period of time, determining the total amount downloaded
 * in that time and total time spent downloading data.  This represents a larger single sample.
 *
 * Time spent allows for periods of time where samples overlap with each other, by counting each overlap only once.
 *
 */
var SampleAggregator = /** @class */ (function () {
    function SampleAggregator(logger) {
        this.samples = [];
        this.logger = logger.withContext('SampleAggregator');
    }
    SampleAggregator.prototype.sample = function (timeToDownloadMs, numBytes, timeRecorded) {
        this.samples.push({ timeToDownloadMs: timeToDownloadMs, numBytes: numBytes, timeRecorded: timeRecorded });
    };
    SampleAggregator.prototype.clearSamples = function () {
        this.samples = [];
    };
    SampleAggregator.prototype.getAggregatedSample = function () {
        if (!this.samples.length) {
            return;
        }
        this.logger.verbose("Aggregator samples: ", this.samples);
        var totalDownloaded = this.samples.reduce(function (acc, _a) {
            var numBytes = _a.numBytes;
            return acc + numBytes;
        }, 0);
        var timeRangesAscending = this.samples
            .map(function (_a) {
            var timeToDownloadMs = _a.timeToDownloadMs, timeRecorded = _a.timeRecorded;
            return ({
                start: timeRecorded - timeToDownloadMs,
                end: timeRecorded,
            });
        })
            .sort(function (a, b) {
            return a.start - b.start;
        });
        var firstTimeRange = timeRangesAscending[0], laterTimeRanges = timeRangesAscending.slice(1);
        var timeRangesNoOverlapsAscending = laterTimeRanges.reduce(function (acc, _a) {
            var _b;
            var start = _a.start, end = _a.end;
            var mostRecentRange = acc[acc.length - 1];
            if (mostRecentRange.end >= start) {
                var newMostRecent = {
                    start: mostRecentRange.start,
                    end: mostRecentRange.end >= end ? mostRecentRange.end : end,
                };
                return Object.assign([], acc, (_b = {}, _b[acc.length - 1] = newMostRecent, _b));
            }
            return __spreadArray(__spreadArray([], acc, true), [{ start: start, end: end }], false);
        }, [firstTimeRange]);
        var totalTimeSpentDownloadingSamples = timeRangesNoOverlapsAscending.reduce(function (acc, _a) {
            var start = _a.start, end = _a.end;
            return acc + end - start;
        }, 0);
        var estimateBytesPerMs = totalDownloaded / totalTimeSpentDownloadingSamples;
        var lastSample = timeRangesNoOverlapsAscending[timeRangesNoOverlapsAscending.length - 1];
        var timeRecorded = lastSample.end;
        return {
            estimateBytesPerMs: estimateBytesPerMs,
            timeRecorded: timeRecorded,
            timeSpentDownloadingMs: totalTimeSpentDownloadingSamples,
        };
    };
    return SampleAggregator;
}());
exports.SampleAggregator = SampleAggregator;
